import { RouteRecordRaw } from 'vue-router'

const Roles = () =>
  import(/* webpackChunkName: "roles-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'roles',
    name: 'roles',
    component: Roles,
    meta: {
      title: 'Roles',
      auth: {
        requiredPermission: 'roles.view',
        requiredModule: 'roles',
        redirect: '/auth/login',
        forbiddenRedirect: '/sas/inicio',
      },
    },
  },
]
